import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4, grey8, grey10 } from 'approot/shared/styles/colours.style';
import { richtextInlineCommonCss } from 'approot/shared/richtext/richtext.style';
import { ActivityBuilderDrawerContent } from 'approot/activity-builder/activity-builder-drawer.style';
import {
  AccordionButton,
  AccordionContent,
  AccordionLabel,
} from 'approot/shared/accordion/accordion-new.style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { flexSpaceBetweenCss } from 'approot/shared/styles/flex.style';
import {
  PStyled,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';

export const RichtextDisplay = styled.div`
  ${richtextInlineCommonCss}
  color: ${grey8};
`;

export const TeachingNotesDrawerContainer = styled(
  ActivityBuilderDrawerContent
)`
  padding: 0;

  ${AccordionButton}, ${AccordionContent} {
    padding-left: ${rem(spacing16)};
    padding-right: ${rem(spacing16)};
  }
  ${AccordionContent} {
    padding-bottom: ${rem(spacing16)};
  }
  ${AccordionLabel} {
    padding: ${rem(spacing16)} 0;
  }
`;

export const TeachingNotesSection = styled.div`
  border-bottom: 1px solid ${grey4};
  padding: ${rem(spacing24)} ${rem(spacing16)};
`;

export const TeachingNotesSectionLabel = styled(PStyled).attrs({
  colour: grey10,
})`
  font-weight: ${fontWeightMedium};
`;

export const TeachingNotesDuration = styled(TeachingNotesSection)`
  ${flexSpaceBetweenCss}
`;
